import styled from 'styled-components'

const List = styled.div`
  margin-bottom: 20px;
`

export { List }
